import classNames from 'classnames';
import Image from 'next/image';
import { FC } from 'react';

import styles from './contactImage.module.scss';

interface ContactImageProps {
  title: string;
  image: string;
  className: string;
}

const ContactImage: FC<ContactImageProps> = (props) => {
  const { title, image, className } = props;
  return (
    <div className={classNames(styles.contactImage, className)}>
      <Image
        alt={title}
        className={styles.contactImage__img}
        height={212}
        src={image}
        width="212"
      />
    </div>
  );
};

ContactImage.displayName = 'ContactImage';

export default ContactImage;
